export default "__VITE_ASSET__ClYpIG8H__"